export default "__VITE_ASSET__DZjYeZH1__"